// Codificador CODE128 (code set B) puro, sin dependencias.
// Genera la secuencia de módulos (barras/espacios) para renderizar el código de
// barras como SVG. El valor human-readable se imprime aparte (fuera del símbolo).

// Tabla de patrones CODE128 (índice = valor de símbolo 0..106). Cada patrón es un
// string binario de 11 bits: '1' = barra, '0' = espacio, siempre empezando en barra.
// Valores 103/104/105 = Start A/B/C, 106 = Stop.
const PATTERNS = [
  '11011001100', '11001101100', '11001100110', '10010011000', '10010001100',
  '10001001100', '10011001000', '10011000100', '10001100100', '11001001000',
  '11001000100', '11000100100', '10110011100', '10011011100', '10011001110',
  '10111001100', '10011101100', '10011100110', '11001110010', '11001011100',
  '11001001110', '11011100100', '11001110100', '11101101110', '11101001100',
  '11100101100', '11100100110', '11101100100', '11100110100', '11100110010',
  '11011011000', '11011000110', '11000110110', '10100011000', '10001011000',
  '10001000110', '10110001000', '10001101000', '10001100010', '11010001000',
  '11000101000', '11000100010', '10110111000', '10110001110', '10001101110',
  '10111011000', '10111000110', '10001110110', '11101110110', '11010001110',
  '11000101110', '11011101000', '11011100010', '11011101110', '11101011000',
  '11101000110', '11100010110', '11101101000', '11101100010', '11100011010',
  '11101111010', '11001000010', '11110001010', '10100110000', '10100001100',
  '10010110000', '10010000110', '10000101100', '10000100110', '10110010000',
  '10110000100', '10011010000', '10011000010', '10000110100', '10000110010',
  '11000010010', '11001010000', '11110111010', '11000010100', '10001111010',
  '10100111100', '10010111100', '10010011110', '10111100100', '10011110100',
  '10011110010', '11110100100', '11110010100', '11110010010', '11011011110',
  '11011110110', '11110110110', '10101111000', '10100011110', '10001011110',
  '10111101000', '10111100010', '11110101000', '11110100010', '10111011110',
  '10111101110', '11101011110', '11110101110', '11010000100', '11010010000',
  '11010011100', '11000111010',
];

const START_B = 104;
const STOP = 106;

// Convierte un patrón binario (string '1'/'0') en anchos de barras/espacios.
function runLengths(binary) {
  const widths = [];
  let i = 0;
  while (i < binary.length) {
    const bit = binary[i];
    let w = 0;
    while (i < binary.length && binary[i] === bit) {
      w += 1;
      i += 1;
    }
    widths.push(w);
  }
  return widths;
}

// Devuelve la secuencia de anchos (barras y espacios alternando, empezando en barra)
// del símbolo CODE128 completo para `text`.
export function code128Widths(text) {
  const s = String(text == null ? '' : text);
  const data = [];
  for (const ch of s) {
    const code = ch.charCodeAt(0);
    if (code < 32 || code > 126) {
      // Fuera de Code Set B: se sustituye por espacio para no romper el símbolo.
      data.push(0);
    } else {
      data.push(code - 32);
    }
  }

  let checksum = START_B;
  for (let i = 0; i < data.length; i++) {
    checksum += data[i] * (i + 1);
  }
  const check = checksum % 103;

  const values = [START_B, ...data, check, STOP];
  const widths = [];
  for (const v of values) {
    widths.push(...runLengths(PATTERNS[v]));
  }
  return widths;
}

// Genera el SVG (string) del código de barras CODE128. `height` en px y
// `moduleWidth` en px por módulo.
export function code128Svg(text, { height = 40, moduleWidth = 2 } = {}) {
  const widths = code128Widths(text);
  if (!widths.length) return '';

  const QUIET = 10; // zona de silencio en módulos
  const totalModules = widths.reduce((a, b) => a + b, 0) + QUIET * 2;
  const totalWidth = totalModules * moduleWidth;

  let x = QUIET * moduleWidth;
  const rects = [];
  for (let i = 0; i < widths.length; i++) {
    const isBar = i % 2 === 0; // empieza en barra
    const w = widths[i] * moduleWidth;
    if (isBar) {
      rects.push(`<rect x="${x}" y="0" width="${w}" height="${height}" fill="#000"/>`);
    }
    x += w;
  }

  return `<svg xmlns="http://www.w3.org/2000/svg" width="${totalWidth}" height="${height}" viewBox="0 0 ${totalWidth} ${height}" preserveAspectRatio="none" shape-rendering="crispEdges">${rects.join('')}</svg>`;
}
